import { useTheme } from '@emotion/react';
import styled from '@emotion/styled';
import { useTranslation } from 'react-i18next';
import { StyledCard } from './StyledCard';
import { StyledStatusBadge } from './StyledStatusBadge';
import { getStatus } from './utils';
type EmissionsCardProps = {
  title: string;
  value: number;
  unit: string;
  deltaPercentage?: number;
};
const StyledEmissionsCardValue = styled.p`
  font-size: ${({
  theme
}) => theme.fontSizeLg};
  margin: 0;
  line-height: 1;
`;
const StyledEmissionsCardUnit = styled.span`
  font-size: ${({
  theme
}) => theme.fontSizeSm};
`;
const StyledEmissionsCardTitle = styled.h5`
  font-size: ${({
  theme
}) => theme.fontSizeSm};
  color: ${({
  theme
}) => theme.textColor.secondary};
`;
export function EmissionsCard({
  title,
  value,
  unit,
  deltaPercentage
}: EmissionsCardProps) {
  const theme = useTheme();
  const {
    t
  } = useTranslation();
  const status = deltaPercentage ? getStatus(deltaPercentage, t, theme) : undefined;
  return <StyledCard data-sentry-element="StyledCard" data-sentry-component="EmissionsCard" data-sentry-source-file="EmissionsCard.tsx">
      <StyledEmissionsCardTitle data-sentry-element="StyledEmissionsCardTitle" data-sentry-source-file="EmissionsCard.tsx">{title}</StyledEmissionsCardTitle>
      <StyledEmissionsCardValue data-sentry-element="StyledEmissionsCardValue" data-sentry-source-file="EmissionsCard.tsx">
        {value.toLocaleString(undefined, {
        maximumFractionDigits: 0
      })}{' '}
        <StyledEmissionsCardUnit data-sentry-element="StyledEmissionsCardUnit" data-sentry-source-file="EmissionsCard.tsx">{unit}</StyledEmissionsCardUnit>
      </StyledEmissionsCardValue>
      {status?.subLabel && <StyledStatusBadge $backgroundColor={status.backgroundColor} $color={status.color}>
          {status.subLabel}
        </StyledStatusBadge>}
    </StyledCard>;
}